import { SEGMENTS, VERTICALS } from '../constants/uriConstants';
import serverVars from 'server-vars';
import get from 'lodash.get';

export function getSellerPath(sellerLabel) {
    return `/${SEGMENTS.SELLER}/${sellerLabel}/`;
}

/**
 * Helper function to deal with the fact that sometimes mobile web pages have the leading segment "/mobile"
 * @param url
 * @returns {[string,*]}
 */
export const stripRoutingSegment = uri => {
    return uri.replace(/^\/(mobile|resp|amp)/, '');
};

function addUrlSearchParamsToPath(urlSearchParams, uriRef) {
    const [path] = uriRef.split('?');

    urlSearchParams.sort();

    let newParamsString = urlSearchParams.toString();
    if (newParamsString) {
        newParamsString = `?${newParamsString}`;
    }

    return `${path}${newParamsString}`;
}

const createUrlSearchParams = (uriRef = '') => {
    return new URLSearchParams(get(uriRef.split('?'), '[1]'));
};

export const createNewUriRef = (uriRef = '', additionalQueryParams) => {
    const existingUrlSearchParams = createUrlSearchParams(uriRef);

    for (const qpKey in additionalQueryParams) {
        if (additionalQueryParams.hasOwnProperty(qpKey)) {
            existingUrlSearchParams.set(qpKey, additionalQueryParams[qpKey]);
        }
    }

    return addUrlSearchParamsToPath(existingUrlSearchParams, uriRef);
};

export const getNewPaginationUriRef = (uriRef, newPage) => {
    const currentUrlSearchParams = createUrlSearchParams(uriRef);

    if (newPage === 1) {
        currentUrlSearchParams.delete('page');
    } else {
        currentUrlSearchParams.set('page', newPage);
    }

    return addUrlSearchParamsToPath(currentUrlSearchParams, uriRef);
};

export const getQueryParam = (uriRef, paramName) => {
    return createUrlSearchParams(uriRef).get(paramName);
};

export function addCdnQueryParams(uriRef) {
    const cdnQueryParams = serverVars.get('cdnQueryParams') || {};
    /**
     * Can be null, can't use defaults. TODO: No reason for it to be null, FIX IT! Can prepopulate
     * it when creating the store.
     */
    if (!uriRef) {
        return '';
    }

    return createNewUriRef(uriRef, cdnQueryParams);
}

export const uriIncludesVertical = (uri = '') => {
    const verticals = Object.values(VERTICALS);
    return !!uri.split('/').find(segment => verticals.includes(segment));
};

export const isDealersShopUri = (uri = '') => {
    const [href] = uri.split('?');
    return !!href.match(/\/dealers\/(.*)\/shop/);
};

export function addTrailingSlash(url) {
    return typeof url === 'string' ? url.replace(/\/?(\?|#|$)/, '/$1') : '/';
}
